var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthForgot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.397,
    height: 66.838,
    viewBox: "0 0 142.397 66.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(-362 -251.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(-948.435 -480.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M1554.674,778.444c-.308-1.589-7.893-5.74-7.893-5.74-1.538-1.435-9.738-2.46-9.738-2.46,1.743-1.64,7.175-2.972,7.175-2.972.718-3.793,4.51-5.125,4.51-5.125,9.532-3.895,17.425,5.228,17.425,5.228s30.751-13.325,36.491-18.245c0,0-7.278,19.475-15.17,21.833a57.345,57.345,0,0,0,7.38.41s-5.638,4.2-8.918,4.408c0,0,5.227,1.435,7.277,1.128,0,0-5.125,4.51-9.43,4.613,0,0,21.218,13.325,28.5,15.99C1612.28,797.509,1559.657,804.193,1554.674,778.444Z",
    transform: "translate(-159.447 0)",
    fill: "#b3e5e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(1329.435 749.128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1329.435,751.6v27.168a2.477,2.477,0,0,0,2.47,2.47h43.22a2.477,2.477,0,0,0,2.47-2.47V751.6a2.477,2.477,0,0,0-2.47-2.47h-43.22A2.477,2.477,0,0,0,1329.435,751.6Zm44.764-.618-19.263,14.448a2.582,2.582,0,0,1-2.841,0l-19.263-14.448Zm-31.215,14.1a.926.926,0,0,0-1.3.137l-10.394,12.84V752.138l19.7,14.772a4.422,4.422,0,0,0,5.063,0l19.7-14.772v25.918l-10.394-12.84a.926.926,0,0,0-1.44,1.166l10.5,12.966c.01.013.024.022.035.035h-41.85c.011-.012.024-.022.035-.035l10.5-12.966A.926.926,0,0,0,1342.984,765.079Z",
    transform: "translate(-1329.435 -749.128)",
    fill: "#172345"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 33,
    height: 1,
    rx: 0.5,
    transform: "translate(362 308)",
    fill: "#172345"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 427.439, 254.633)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.068,0,8.136,6.974H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.068130970001221 1.984635829925537 L 1.74103832244873 5.973939418792725 L 6.395223617553711 5.973939418792725 L 4.068130970001221 1.984635829925537 M 4.068130970001221 -4.76837158203125e-07 L 8.136260986328125 6.973939418792725 L 9.5367431640625e-07 6.973939418792725 L 4.068130970001221 -4.76837158203125e-07 Z",
    stroke: "none",
    fill: "#172345"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(369 266)",
    fill: "none",
    stroke: "#06bab5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthForgot);
export default __webpack_public_path__ + "static/media/auth-forgot.2e78d850bf26eb8db72614e7d25e2303.svg";
export { ForwardRef as ReactComponent };